/**
 * Created by why on 2019/10/21.
 */
import {
  query,
  add,
  edit
} from '@/api/setting-manage'

export default {
  state: {
    settingList: [],
    loading: false,
    loadingSave: false,
    messageInfo: null
  },
  mutations: {
    setSettingList (state, list) {
      state.settingList = list
    }
  },
  getters: {
    settingList: state => state.settingList
  },
  actions: {
    settingAdd ({ state, commit }, {data}) {
      commit('setLoadingSave', true)
      return new Promise((resolve, reject) => {
        add(
          data
        ).then(res => {
          const message = res.data.message
          commit('setLoadingSave', false)
          resolve(message)
        }).catch(err => {
          commit('setLoadingSave', false)
          reject(err)
        })
      })
    },
    settingEdit ({ state, commit }, {data}) {
      commit('setLoadingSave', true)
      return new Promise((resolve, reject) => {
        edit(
          data
        ).then(res => {
          const message = res.data.message
          commit('setLoadingSave', false)
          resolve(message)
        }).catch(err => {
          commit('setLoadingSave', false)
          reject(err)
        })
      })
    },
    findByName ({ state, commit }, {name}) {
      return new Promise((resolve, reject) => {
        query(
          name
        ).then(res => {
          const list = res.data
          commit('setSettingList', list)
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/setting-manage.js